<div class="login-container">
  <div class="login-background">
    <div class="branding-section">
      <img ngSrc="assets/login-bg1.webp"  fetchpriority="high" fill priority alt="" class="branding-image" />

      <div class="brand-logo">
        <img src="assets/Alphastar_Logo_png.webp" alt="Logo" class="logo" />
      </div>

      <div class="brand-content">
        <h1>Because every minute <br />on the ground matters.</h1>
        <p>Track, manage, and execute ground operations efficiently</p>
      </div>
    </div>

    <div class="form-section">
      <div class="form-card">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-body">
          <div class="form-header">
            <h1>Sign in to your account</h1>
            <p>Sign in to access your operations dashboard</p>
          </div>

          <div class="form-inputs">
            <app-custom-input
              id="username"
              formControlName="username"
              label="Email Address"
              placeholder="Enter your email address"
            ></app-custom-input>
            <app-custom-password-input
              id="password"
              formControlName="password"
              label="Password"
              placeholder="Enter your password"
            ></app-custom-password-input>
          </div>
          <div class="form-button">
            <button
              style="height: 48px"
              type="submit"
              [disabled]="(isLoading$ | async) || false"
              class="sign-in-btn"
            >
              @if ((isLoading$ | async) || false) {
              <div class="loader"></div>
              } @else { Sign In }
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
